module.exports = __webpack_public_path__ + "static/media/Shuqi.251edf7d.png";